import i18n from "i18next";

export const convertBooleanToYesOrNo = (value: boolean | undefined, withoutNo = false): string =>
  i18n.t(value ? "common_words.yes" : !withoutNo ? "common_words.no" : "");
